import { j as r } from "../../../../jsx-runtime-CQ7OqOhn.js";
import { helperIconOptions as c } from "./HelpText.consts.js";
import "../../../atoms/Button/Button.styles.js";
import "@fortawesome/pro-duotone-svg-icons";
import e from "../../../atoms/Icon/Icon.js";
import "../../../../tailwindConfig/bclTwMerge.js";
import "@radix-ui/react-checkbox";
import "../../../atoms/Checkbox/Checkbox.styles.js";
import "@fortawesome/pro-solid-svg-icons";
import "../../../atoms/Loader/SYFLoader/SyfLoader.js";
import "../../../atoms/ProgressIndicator/ProgressIndicator.styles.js";
import "react";
import "@radix-ui/react-select";
import "../../../atoms/TextField/TextField.styles.js";
import "../../../atoms/TextLink/TextLink.styles.js";
import "../../../atoms/Chip/Chip.styles.js";
import "@radix-ui/react-radio-group";
import "../../../atoms/RadioItem/RadioItem.styles.js";
const k = ({
  id: o,
  helperText: t,
  helperIcon: i
}) => {
  if (!t || !(t != null && t.length)) return null;
  const m = Array.isArray(t), a = m ? t : [t];
  return /* @__PURE__ */ r.jsx(r.Fragment, { children: a.map((s, p) => {
    const n = m ? `${o}-helper-text-${p}` : `${o}-helper-text`;
    return /* @__PURE__ */ r.jsxs(
      "p",
      {
        className: "flex items-center text-caption-xs",
        "data-testid": n,
        children: [
          p === 0 && i && /* @__PURE__ */ r.jsx(
            e,
            {
              className: "mr-1",
              icon: c[i],
              "data-testid": `${o}-helper-icon`
            }
          ),
          s
        ]
      },
      s
    );
  }) });
};
export {
  k as default
};
